import React from "react";
import { Tooltip } from "antd";
import type { MemberBadge } from "./MemberBadgeType";
import "./MemberNickname.css";

export function MemberBadgeStrip({
  badges,
  className = "",
}: {
  badges?: MemberBadge[] | null;
  className?: string;
}): JSX.Element | null {
  const list = (badges ?? []).filter(
    (b) =>
      b?.memberBadgeIconUrl?.trim() &&
      b?.memberDisplayName?.trim()
  );
  if (list.length === 0) return null;
  return (
    <span className={`lf-member-badge-strip ${className}`.trim()} aria-hidden>
      {list.map((b) => (
        <Tooltip key={b.spaceProductId} title={b.memberDisplayName.trim()}>
          <img
            className="lf-member-badge-icon"
            src={b.memberBadgeIconUrl.trim()}
            alt=""
          />
        </Tooltip>
      ))}
    </span>
  );
}

export function MemberNickname({
  nickname,
  badges,
  className = "",
}: {
  nickname: React.ReactNode;
  badges?: MemberBadge[] | null;
  className?: string;
}): JSX.Element {
  return (
    <span className={`lf-member-nickname ${className}`.trim()}>
      <span className="lf-member-nickname__text">{nickname}</span>
      <MemberBadgeStrip badges={badges} />
    </span>
  );
}
